import type { Action } from 'state/actions';
import type { BatchFormsCloneRequested } from 'state/batchForm/batchForm.action';
import * as batchTypes from 'state/batchForm/batchForm.actionTypes';
import { addKeys, addOrReplaceKey, removeKey, removeKeys } from 'state/utils/collection';

import * as addonManagementTypes from '../../addonManagementForm/addonManagementForm.actionTypes';
import type { FormDataStateMap } from '../formData.model';

export function pendingEnrichmentReducer(state: FormDataStateMap = {}, action: Action): FormDataStateMap {
  switch (action.type) {
    case 'WORKSPACE_RESET_TAB_REQUESTED':
      return removeKey(state, action.tabId);
    case 'WORKSPACE_TAB_REMOVED':
      return removeKey(state, action.id);
    case 'FORM_ENRICHED_DATA_RECEIVED':
      const newState = removeKey(state, action.formId);
      return newState;
    case 'PRODUCT_CODES_REJECTED':
      return removeKey(state, action.tabId);
    case 'PRODUCT_CODES_REQUESTED':
      return addOrReplaceKey(state, action.tabId, { _productCodes: 'Reloading' });
    case 'FORM_ENRICHMENT_REQUESTED':
      return addOrReplaceKey(state, action.formId, action.patch);
    case 'FORM_ENRICHMENT_FAILED':
      return removeKey(state, action.tabId);
    case batchTypes.BATCH_FORM_ENRICHMENT_FAILED:
      return removeKey(state, action.formId);
    case addonManagementTypes.ADDON_MANAGEMENT_FORM_ENRICHMENT_FAILED:
      return removeKey(state, action.formId);
    case batchTypes.DEFAULT_BATCH_FORM_RECEIVED:
      return removeKey(state, action.negotiationId);
    case batchTypes.DEFAULT_BATCH_FORM_FAILED:
      return removeKey(state, action.temporaryFormId);
    case batchTypes.BATCH_FORMS_DELETED:
      return removeKeys(state, action.formIds);
    case batchTypes.BATCH_FORMS_CLONE_REQUESTED:
      return onBatchFormsCloneRequested(state, action);
    default:
      return state;
  }
}

function onBatchFormsCloneRequested(state: FormDataStateMap, action: BatchFormsCloneRequested): FormDataStateMap {
  return addKeys(state, action.temporaryFormIds, Object.values(action.formsToBeCloned), {
    action,
    reducer: 'formData/pendingEnrichment',
  });
}
